// extracted by mini-css-extract-plugin
export default {"labyrinthSvg":"labyrinthSvg_labyrinthSvg__WyEnR"};